import { FC } from 'react'


const ConnectAwait: FC = () => {
  return null
}

export default ConnectAwait